import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WhatIDoSection } from '../components/WhatIDoSection';
import { HeroTestimonial } from '../components/HeroTestimonial';
import { HowItWorks } from '../components/HowItWorks';
import { SupportingTestimonials } from '../components/SupportingTestimonials';
import { CredibilityBar } from '../components/CredibilityBar';
import { CtaSection } from '../components/CtaSection';
import { HomeNewsletterSignup } from '../components/HomeNewsletterSignup';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen flex flex-col w-full bg-white font-body" data-id="element-506" data-mp="36rmzocxcom9u">
      <Navigation data-id="element-507" data-mp="31ytszjibn3v4" />
      <main className="flex-grow" data-id="element-508" data-mp="31yalyxu7lzvv">
        <HeroSection data-id="element-509" data-mp="2ea12i2kgxo7w" />
        <WhatIDoSection data-id="element-510" data-mp="2e97wj3tc32qt" />
        <HowItWorks data-id="element-511" data-mp="2e8gb2ltgale9" />
        <HeroTestimonial data-id="element-512" data-mp="2e7wsd2vz7sz6" />
        <SupportingTestimonials data-id="element-513" data-mp="29b6cogo32zea" />
        <CredibilityBar data-id="element-514" data-mp="299vc0ppxq7re" />
        <CtaSection data-id="element-515" data-mp="29ao88wr9peva" />
        <HomeNewsletterSignup data-id="element-516" data-mp="2993n1xquf8a3" />
      </main>
      <Footer data-id="element-517" data-mp="2antt8taiunej" />
    </div>;
}